<template>
  <div class="row">
    <div class="col-12">
      <div class="form-row form-group">
        <label class="col-lg-1 col-form-label" for="sale_channel"
          >ช่องทางการขาย</label
        >
        <div class="col-sm-9 col-form-label">
          <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-checkbox-group
              id="checkbox-group-1"
              v-model="channelSelected"
              :options="options"
              :aria-describedby="ariaDescribedby"
              name="channel-checkbox"
              :disabled="isDisabled"
            ></b-form-checkbox-group>
          </b-form-group>
        </div>
      </div>
    </div>
    <div class="col-12">
      <b-table
        class="line-height"
        :empty-text="'ไม่พบข้อมูล'"
        :show-empty="
          items === null || items === undefined || (items && items.length === 0)
        "
        :striped="true"
        :bordered="true"
        v-bind:items="items"
        v-bind:fields="fields"
      >
        <!-- <template v-slot:cell(index)="data">
          {{ (data.index + 1) | number }}
        </template> -->
        <template #head(selectCheckbox)="data">
          <b-form-checkbox
            @click.native.stop
            v-model="isSelectAll"
            @change="onSelectAll($event)"
            :disabled="isDisabled"
            class="btn-check"
          ></b-form-checkbox>
        </template>
        <template v-slot:cell(selectCheckbox)="data">
          <b-form-checkbox
            @click.native.stop
            @change="onSelectCheckbox($event, data.item)"
            v-model="data.item.checkbox"
            :disabled="isDisabled"
          ></b-form-checkbox>
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
import { FormatQty } from '@/helpers/utils/format-qty.js'
import channelService from '@/helpers/service/channel-service'
import { StatusEnum } from '@/enum/status.enum.js'
import { eventBus } from '@/main.js'

export default {
  name: 'TableSelectChannel',
  props: {
    value: {
      type: Array,
      default: () => {
        return this.items
      },
    },
    isDisabled: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    business_unit : {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      channelSelected: [],
      options: [
        // { text: 'Offline', value: 'Offline' },
        // { text: 'Online', value: 'Online' },
        { text: 'OFM Offline', value: 'OFM Offline' ,disabled : true},
        { text: 'OFM Online', value: 'OFM Online' ,disabled : true},
        { text: 'B2S Offline', value: 'B2S Offline' ,disabled : true},
        { text: 'B2S Online', value: 'B2S Online',disabled : true },
      ],
      optionsTemp: [
        // { text: 'Offline', value: 'Offline' },
        // { text: 'Online', value: 'Online' },
        { text: 'OFM Offline', value: 'OFM Offline' ,disabled : true},
        { text: 'OFM Online', value: 'OFM Online' ,disabled : true},
        { text: 'B2S Offline', value: 'B2S Offline' ,disabled : true},
        { text: 'B2S Online', value: 'B2S Online',disabled : true },
      ],
      fields: [
        {
          key: 'selectCheckbox',
          label: '',
          class: 'text-center',
          thClass: 'w-30-px',
          sortable: false,
        },
        // {
        //   key: 'index',
        //   formatter: (value, key, item) => {
        //     return FormatQty(value ? value : 0)
        //   },
        //   label: '#',
        //   thClass: 'w-50-px',
        //   tdClass: 'text-center',
        //   sortable: false,
        // },
        {
          key: 'display_name.en',
          label: 'ช่องทางการขาย',
          thClass: '',
          tdClass: '',
          sortable: false,
        },
        {
          key: 'group',
          label: 'ประเภท',
          thClass: '',
          tdClass: 'text-center',
          sortable: false,
        },
      ],
      items: [],
      tmpItem : [],
      isSelectAll: false,
      isFirstWatchValue: true,
    }
  },
  watch: {
    value: {
      handler(val) {
        if (this.isFirstWatchValue) {
          this.onGetChannelAsync()
        } else {
          // console.log(val)
          // console.log(this.items)
          this.items = this.items.map(it => ({
            ...it,
            checkbox: this.value.some(
              it2 => it2.checkbox === true && it2.id === it.id
            ),
          }))
        }
      },
      deep: true,
    },
    channelSelected: {
      handler: function(val) {
        this.items.forEach(function(element) {
          element.checkbox = val.some(s => s.split(' ')[1] == element.group && s.split(' ')[0] == element.business_unit) ? true : false
        })
        this.$emit(
          'input',
          this.items.filter(function(e) {
            return e.checkbox === true
          })
        )
      },
      deep: true,
    },
    items: {
      handler: function(val) {
        this.$nextTick(() => {
          this.isSelectAll =
            val.filter(function(e) {
              return e.checkbox === true
            }).length === val.length
              ? true
              : false
        })
      },
      deep: true,
    },
    business_unit:{
      handler: function(val) {
        this.onCheckChannelByBU(val)
      },
      deep: true,
    }
  },
  async mounted() {
    this.$nextTick(async () => {
      await this.onGetChannelAsync()
    })
  },
  methods: {
    onCheckChannelByBU(val){
      this.items = []
      this.options = []
        if(val.length > 0){
          if(val.some(w=>w == "OFM")){
            this.tmpItem.filter(w=>w.business_unit == "OFM").forEach(ss=>{
              this.items.push(ss)
            })
            this.options.push({ text: 'OFM Offline', value: 'OFM Offline' ,disabled : true})
            this.options.push({ text: 'OFM Online', value: 'OFM Online' ,disabled : true})
          }
          if(val.some(w=>w == "B2S")){
            this.tmpItem.filter(w=>w.business_unit == "B2S").forEach(ss=>{
              this.items.push(ss)
            })
            this.options.push({ text: 'B2S Offline', value: 'B2S Offline' ,disabled : true})
            this.options.push({ text: 'B2S Online', value: 'B2S Online' ,disabled : true})
          }

          
          this.options.forEach(item =>{
            if(val.some(s => item.text.includes(s))){
              item.disabled = false
            }else{
              item.disabled = true
            }
          })
        }else{
          this.tmpItem.forEach(ss=>{
              this.items.push(ss)
            })
        }
    },
    onSelectAll(value) {
      this.items.forEach(element => {
        element.checkbox = value
      })
      this.$emit(
        'input',
        this.items.filter(function(e) {
          return e.checkbox === true
        })
      )
    },
    onSelectCheckbox(value, object) {
      console.log("onSelectCheckbox",value, object)
      this.$nextTick(() => {
        let _channel = this.items.find(w=>w.id == object.id)
        if(_channel != undefined){
          _channel.checkbox = value
        }

        // this.items[object.index].checkbox = value
        this.$emit(
          'input',
          this.items.filter(function(e) {
            return e.checkbox === true
          })
        )
      })
    },
    async onGetChannelAsync() {
      
      let params = new URLSearchParams()
      params.append('status', StatusEnum.ACTIVE)
      params.append('sort', '_id')
      let result = await channelService.getChannelMasterListAsync(params)
      if (result.status === 200) {
        //Checkbox ตาม value ที่ props เข้ามา
        let selectedItems =
          this.value && this.value.length > 0 ? this.value.map(m => m.id) : []

        let channelItems = []
        this.tmpItem = []
        result.data.items.forEach((element, index) => {
          channelItems[index] = {
            checkbox: selectedItems.some(s => s == element.id) ? true : false,
            index: index,
            id: element.id,
            group: element.group,
            display_name: {
              en: element.display_name.en,
              th: element.display_name.th,
            },
            business_unit : element.business_unit
          }
          this.tmpItem.push(channelItems[index])
        })
        this.items = channelItems
        console.log("this.tmpItem",this.tmpItem,this.items)
        this.onCheckChannelByBU(this.business_unit)
        if (selectedItems.length > 0) {
          this.isFirstWatchValue = false
        }
      } else {
        console.log('error', result.response.data.message)
      }
    },
  },
}
</script>
<style scoped>
.aaa{
  color: brown;
}
</style>
